// extracted by mini-css-extract-plugin
export var background = "_63-0";
export var buttonPrimary = "_63-1";
export var container = "_63-2";
export var containerTopLayerApi = "_63-3";
export var feature = "_63-6";
export var featureBody = "_63-7";
export var featureIcon = "_63-8";
export var featureSummary = "_63-a";
export var featureTitle = "_63-9";
export var modal = "_63-g";
export var modalAction = "_63-f";
export var modalCloseButton = "_63-e";
export var modalFeatures = "_63-5";
export var modalFooter = "_63-b";
export var modalImageLogo = "_63-c";
export var modalLogo = "_63-d";
export var redoModal = "_63-4";